import PropTypes from 'prop-types';

var propTypes = {
    required: PropTypes.bool,
    primaryCondition: PropTypes.string,
    secondaryCondition: PropTypes.string,
    isValid: PropTypes.bool,
    withDividers: PropTypes.bool,
    isDisabled: PropTypes.bool,
    'data-testid': PropTypes.string,
    className: PropTypes.string,
    controlClassName: PropTypes.string,
};
var defaultProps = {
    required: false,
    primaryCondition: '',
    secondaryCondition: '',
    isValid: true,
    withDividers: true,
};

export { defaultProps, propTypes };
